export const Settings = {
    version: '2.8.10'
}
